<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.jsmd1">
      </p>
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:18px;font-family:宋体;">Mg Ingots</span>
        </b>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Mg
          99.9%min
        </span>
      </p>
      <p>
        <br>
        <span style="font-size:12pt;font-family:Arial;"></span>
      </p>
      <p>
        <img :src="images.jsmd2">
      </p>
      <p>
        <span style="font-size:12pt;font-family:Arial;"></span>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Mg Granulars</span>
        </b>
      </p>
      <span style="font-size:12.0pt;font-family:Arial;">
        <span style="font-size:12px;">
          (1) Mg
          99.9%min (2) Mg 97%+CaO 3%
        </span>
      </span>
      <p>
        <br>
      </p>
      <p>
        <br>
        <span style="font-size:12pt;font-family:Arial;"></span>
      </p>
      <p>
        <img :src="images.jsmd3">
      </p>
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:18px;font-family:宋体;">Calcium Granulars</span>
        </b>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Ca 98.5% min</span>
        <span style="font-size:12px;font-family:宋体;">，</span>
        <span style="font-size:12px;font-family:Arial;">Al 0.5% max</span>
        <span style="font-size:12px;font-family:宋体;">，</span>
        <span style="font-size:12px;font-family:Arial;">
          Mg
          0.5% max
        </span>
        <span style="font-size:12px;font-family:宋体;">，</span>
        <span style="font-size:12px;font-family:Arial;">Cu 0.003% max&nbsp;</span>
      </p>
      <p>
        <b style="text-indent:12.05pt;line-height:1.5;">
          <u>
            <span style="font-size:12px;font-family:宋体;">Size</span>
          </u>
        </b>
        <b style="text-indent:12.05pt;line-height:1.5;">
          <span style="font-size:12px;font-family:Arial;">:</span>
        </b>
        <span style="text-indent:12.05pt;font-size:12px;font-family:Arial;">0-0.20mm&nbsp;5% max</span>
        <span style="text-indent:12.05pt;font-size:12px;font-family:宋体;">，</span>
        <span style="text-indent:12.05pt;font-size:12px;font-family:Arial;">0.2-2.5mm 95% min</span>
        <span style="text-indent:12.05pt;font-size:12px;font-family:宋体;">，</span>
      </p>
      <p style="text-indent:12.05pt;">
        <span style="font-size:12px;font-family:Arial;">&gt;2.5 mm&nbsp;0%</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        jsmd1: require("../../../assets/img/common/jsmd1.jpg"),
        jsmd2: require("../../../assets/img/common/jsmd2.jpg"),
        jsmd3: require("../../../assets/img/common/jsmd3.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/product/jsmd.vue